// src/pages/Contact.js
import React, { useState } from 'react';
import { createLead, uploadAttachment } from '../api/leadsApi';
import './Contact.css';

const initial = {
  fullName: '',
  email: '',
  phone: '',
  serviceType: '',
  details: '',
  preferredStartDate: '',
  attachmentUrl: ''
};

const Contact = () => {
  const [form, setForm] = useState(initial);
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleUpload = async () => {
    if (!file) return '';
    const res = await uploadAttachment(file);
    return res.data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });
    try {
      const attachmentUrl = file ? await handleUpload() : form.attachmentUrl;
      await createLead({ ...form, attachmentUrl });
      setStatus({ type: 'success', message: '✅ Thanks! We received your request.' });
      setForm(initial);
      setFile(null);
    } catch (err) {
      setStatus({ type: 'error', message: '❌ Submission failed. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container">
      <h2>Contact / Request a Quote</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <input name="fullName" value={form.fullName} onChange={handleChange} placeholder="Full name" required />
          <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email" required />
          <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" />
        </div>

        <div className="form-group">
          <select name="serviceType" value={form.serviceType} onChange={handleChange} required>
            <option value="">Select service</option>
            <option>Software Development</option>
            <option>AI Solutions</option>
            <option>Training Bootcamp</option>
            <option>Other</option>
          </select>
        </div>

        <textarea name="details" value={form.details} onChange={handleChange} placeholder="Tell us about your project" />

        <div className="form-group">
          <label className="date-label">Preferred Start Date:</label>
          <input type="date" name="preferredStartDate" value={form.preferredStartDate} onChange={handleChange} />
        </div>

        <div className="file-upload">
          <label>Attachment (optional):</label>
          <input type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          {file && <p className="file-name">📎 {file.name}</p>}
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send Request'}
        </button>
      </form>

      {status.message && (
        <p className={`status-message ${status.type}`}>
          {status.message}
        </p>
      )}
    </div>
  );
};

export default Contact;
